<template>
  <el-card shadow="never"
           class="aui-card--fill">
    <div class="mod-joylearning__assignmanage}">
      <!-- :inline="true" -->
      <el-form label-width="auto"
               label-position="left"
               :model="dataForm"
               @keyup.enter.native="getDataList()">
        <el-row class="margb10">
          <el-col :span="7">
            <!-- 选择课程 prop="selectCourse" -->
            <el-form-item class="search-item">
              <span slot="label">
                <el-popover placement="bottom"
                            width="800"
                            trigger="click">
                  <el-link slot="reference">选择课程</el-link>
                  <offeringCoursedlist @offeringcodelist="offeringcodelist"
                                       @offeringlistk="offeringlistk"></offeringCoursedlist>
                </el-popover>
              </span>
              <el-input v-model="dataForm.courseCode"
                        disabled
                        :placeholder="$t('registe.select')"></el-input>
            </el-form-item>
            <!-- </el-form-item> -->
          </el-col>
          <!-- 排期编号 -->
          <el-col :span="7">
            <el-form-item :label="$t('registe.offeringcode')" class="search-item">
              <el-input v-model="dataForm.offeringCode"
                        :placeholder="$t('registe.input')"></el-input>
            </el-form-item>
          </el-col>
          <!-- 排期名称 -->
          <el-col :span="7">
            <el-form-item :label="$t('registe.offeringname')" class="search-item">
              <el-input v-model="dataForm.offeringname"
                        :placeholder="$t('registe.input')"></el-input>
            </el-form-item>
          </el-col>
          <!-- 查询 -->
          <el-col :span="3">
            <el-col :span="24">
              <el-button class="M-search"
                         style="margin-bottom: 7px"
                         type="primary"
                         @click="getDataListMerge">{{$t('query')}}</el-button>
            </el-col>
          </el-col>
        </el-row>
        <!-- ---->
        <el-row class="margb10">
          <!-- 所在城市 -->
          <el-col :span="7">
            <el-form-item :label="$t('registe.city')" class="search-item">
              <el-input v-model="dataForm.city"
                        :placeholder="$t('registe.input')"></el-input>
            </el-form-item>
          </el-col>
          <!-- 所在场地 -->
          <el-col :span="7">
            <el-form-item :label="$t('registe.place1')" class="search-item">
              <el-input v-model="dataForm.siteName"
                        :placeholder="$t('registe.input')"></el-input>
            </el-form-item>
          </el-col>
          <!-- 排期状态 -->
          <el-col :span="7">
            <el-form-item :label="$t('registe.offeringstatus')"
                          class="search-item"
                          prop="offeringstatus">
              <el-select v-model="dataForm.offeringStatus"
                         multiple
                         collapse-tags
                         :placeholder="$t('cert.select')">
                <el-option v-for="(item,index) in offeringStatusArr"
                           :key="index"
                           :label="item.name"
                           :value="item.code"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 重置 -->
          <el-col :span="3">
            <el-col :span="24">
              <el-button class="el-back M-search M-margin-l"
                         type="info"
                         @click="again">{{$t('reset')}}</el-button>
            </el-col>
          </el-col>
        </el-row>
        <el-row class="margb10">
          <!--开始时间-->
          <!-- <el-col :span="5">
            <el-form-item :label="$t('registe.startdate')"
                          prop="dataForm.startDate">
              <el-date-picker v-model="dataForm.startDate"
                              :placeholder="$t('registe.startdate')"
                              type="date"
                              value-format="yyyy-MM-dd" />
            </el-form-item>
          </el-col> -->
          <el-col :span="7">
            <el-form-item :label="$t('offering.startdate')" class="search-item">
              <el-date-picker style="width:130%"
                              v-model="startdateRange"
                              type="daterange"
                              format="yyyy-MM-dd"
                              range-separator="至"
                              start-placeholder="开始日期"
                              end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <!--结束时间-->
          <el-col :span="7">
            <!-- 结束时间  -->
            <el-form-item :label="$t('offering.enddate')" class="search-item">
              <el-date-picker style="width:130%"
                              v-model="enddateRange"
                              type="daterange"
                              format="yyyy-MM-dd"
                              range-separator="至"
                              start-placeholder="开始日期"
                              end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="5">
            <el-form-item :label="$t('registe.enddate')"
                          prop="dataForm.endDate">
              <el-date-picker v-model="dataForm.endDate"
                              :placeholder="$t('registe.enddate')"
                              type="date"
                              value-format="yyyy-MM-dd" />
            </el-form-item>
          </el-col> -->
        </el-row>
        <!-- 高级搜索 --->
        <div v-show="isShow">
        </div>
      </el-form>
      <ToggleDiv @toggle="toggle"></ToggleDiv>
      <!-- 表头动态展示(还得改)
      -->
      <el-table v-loading="dataListLoading"
                :data="dataList"
                border
                @selection-change="dataListSelectionChangeHandle"
                style="width: 100%;">
        <!--选择框-->
        <!-- <el-table-column type="selection"
                         header-align="center"
                         align="center"
                         width="50"></el-table-column> -->
        <!--报名ID-->
        <el-table-column prop="registeId"
                         :label="registeId"
                         type="index"
                         v-if="isShowID"></el-table-column>
        <!--排期ID-->
        <el-table-column prop="offeringId"
                         :label="offeringId"
                         type="index"
                         v-if="isShowID"></el-table-column>
        <!--课程ID-->
        <el-table-column prop="courseId"
                         :label="courseId"
                         type="index"
                         v-if="isShowID"></el-table-column>
        <!--排期编号-->
        <el-table-column prop="offeringNo"
                         :label="$t('registe.offeringcode')"
                         width="110"
                         align="center"
                         fixed>
          <template slot-scope="scope">
            <el-button type="text"
                       size="small"
                       @click="showOfferingView(scope)">{{scope.row.offeringNo}}</el-button>
          </template>
        </el-table-column>
        <!--课程编号-->
        <el-table-column prop="courseCode"
                         :label="$t('registe.coursecode')"
                         header-align="center"
                         align="center"
                         width="110"
                         fixed>
          <template slot-scope="scope">
            <el-button type="text"
                       size="small"
                       @click="showCourseView(scope)">{{scope.row.courseCode}}</el-button>
          </template>
        </el-table-column>
        <!--课程名称-->
        <el-table-column prop="courseNameCn"
                         :label="$t('registe.coursename')"
                         header-align="center"
                         align="center"
                         fixed>
          <template slot-scope="scope">
            <el-button type="text"
                       size="small"
                       @click="showCourseView(scope)">{{scope.row.courseNameCn}}</el-button>
          </template>
        </el-table-column>
        <!--培训师-->
        <el-table-column prop="trainerName"
                         :label="$t('registe.trainer')"
                         header-align="center"
                         align="center"
                         width="110"></el-table-column>
        <!--排期名称-->
        <el-table-column prop="offeringName"
                         :label="$t('registe.offeringname')"
                         header-align="center"
                         align="center"
                         width="180"></el-table-column>
        <!--场地-->
        <el-table-column prop="site"
                         :label="$t('registe.place2')"
                         header-align="center"
                         align="center"
                         width="180"></el-table-column>
        <!--开始时间-->
        <el-table-column prop="startdate"
                         :label="$t('registe.startdate')"
                         header-align="center"
                         align="center"
                         :formatter="dateFormat"
                         width="90"></el-table-column>
        <!--结束时间-->
        <el-table-column prop="enddate"
                         :label="$t('registe.enddate')"
                         header-align="center"
                         align="center"
                         :formatter="dateFormat"
                         width="90"></el-table-column>
        <!--实际培训时间-->
        <el-table-column prop="coursedays"
                         :formatter="courseDaysformat"
                         :label="$t('registe.trainday')"
                         header-align="center"
                         align="center"
                         width="50"></el-table-column>
        <!--报名人数-->
        <el-table-column prop="applyNumber"
                         :label="applyNumber"
                         type="index"
                         v-if="isShowID"></el-table-column>
        <!--报名/上限-->
        <el-table-column prop="applyCountNumber"
                         :label="$t('registe.applycount')"
                         header-align="center"
                         align="center"
                         width="80">
          <template slot-scope="scope">
            <el-button type="text"
                       size="small"
                       @click="showUserView(scope)">{{scope.row.applyCountNumber}}</el-button>
          </template>
        </el-table-column>
        <!-- 操作 -->
        <el-table-column :label="$t('handle')"
                         fixed="right"
                         align="center"
                         width="150">
          <template slot-scope="scope">
            <!-- 查看 -->
            <div style="width: 80px; float: left;">
              <el-dropdown-item @click.native="showOfferingView(scope)">{{ $t('view') }}</el-dropdown-item>
            </div>
            <div>
              <el-dropdown trigger="click"
                           placement="bottom">
                <span class="el-dropdown-link">
                  {{ $t('handle') }}<em class="el-icon-caret-bottom el-icon--right"></em>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <!-- 分配 -->
                  <el-dropdown-item @click.native="assignUser(scope.row)">{{ $t('registe.assign') }}</el-dropdown-item>
                  <!-- 人员名单 -->
                  <el-dropdown-item v-if="scope.row.applyNumber > 0"
                                    @click.native="showUserView(scope)">{{ $t('registe.showuser') }}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination :current-page="page"
                     :page-sizes="[10, 20, 50, 100]"
                     :page-size="limit"
                     :total="total"
                     layout="total, sizes, prev, pager, next, jumper"
                     @size-change="pageSizeChangeHandle"
                     @current-change="pageCurrentChangeHandle"></el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <assign-user v-if="assignUserVisible"
                   ref="assignUser"
                   @refreshDataList="getDataList"></assign-user>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import ToggleDiv from '@/components/toggle-div'
import assignUser from './assignuser'
import offeringCoursedlist from '../../offering/offeringcommon/offeringCoursedlist'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListIsPage: true,
        getDataListURL: '/learning/offeringregiste/pageAssignInfo',
        addURL: '/learning/offeringregiste/add'// 分配增加一条记录
      },
      // 类型
      offeringStatusArr: this.enums['offeringStatus'],
      dataList: [],
      dataForm: {
        courseCode: '', // 课程编号
        offeringCode: '', // 排期编号
        offeringName: '', // 排期名称
        offeringStatus: '', // 排期状态
        city: '', // 所在城市
        site: '', // 所在场地
        siteName: '', // 所在场地
        startStartDate: '', // 开始时间
        startEndDate: '',
        endStartDate: '', // 结束时间
        endEndDate: '',
        courseid: '', // 课程ID
        coursename: '' // 课程名称
      },
      // 等待转圈
      dataListLoading: false,
      // 是否显示分配用户
      assignUserVisible: false,
      isShow: false,
      isShowID: false,
      checkAll: false,
      startdateRange: [],
      enddateRange: []
    }
  },
  components: {
    ToggleDiv,
    assignUser,
    offeringCoursedlist
  },
  created () {
    // this.mixinViewModuleOptions.getDataListURL =
    //   '/learning/offeringregiste/pageAssignInfo'
    // this.mixinViewModuleOptions.getDataListIsPage = true
    // this.getDataList()
  },
  methods: {
    offeringlistk: function () {
      this.dataForm.coursename = ''
      this.dataForm.courseid = ''
      this.dataForm.courseCode = ''
    },
    // 选择课程时调用
    offeringcodelist: function (data) {
      let couresid = ''
      let couresName = ''
      let courseCode = ''

      data = this.quchong(data)
      data.forEach(rows => {
        console.log(rows)

        couresid = couresid + rows.couresid + ','
        couresName = couresName + rows.couresName + ','
        courseCode = courseCode + rows.courseCode + ','
      })
      var string = this.dataForm.coursename + ',' + couresName
      var stringid = this.dataForm.courseid + ',' + couresid
      var stringcode = this.dataForm.courseCode + ',' + courseCode
      string = this.quchongstr(string)
      string = string.replace(',', '')
      stringid = this.quchongstr(stringid)
      stringid = stringid.replace(',', '')
      stringcode = this.quchongstr(stringcode)
      stringcode = stringcode.replace(',', '')
      this.dataForm.coursename = string
      this.dataForm.courseid = stringid
      this.dataForm.courseCode = stringcode
      console.log(courseCode)
    },
    /* 字符串去重 */
    quchongstr (str) {
      var a = str.split(',')
      a.sort()
      for (var i = a.length - 1; i > 0; i--) {
        if (a[i] === a[i - 1]) {
          a.splice(i, 1)
        }
      }
      return a.join(',')
    },
    quchong (arr) {
      var result = []
      var obj = {}
      for (var i = 0; i < arr.length; i++) {
        if (!obj[arr[i].couresName]) {
          result.push(arr[i])
          obj[arr[i].couresName] = true
        }
      }
      return result
    },
    // 查询
    getDataListMerge () {
      /* eslint-disable */
      // debugger
      // if (this.dataForm.startDate === '' || this.dataForm.startDate === null) {
      //   this.dataForm.startDate = ''
      // }
      // if (this.dataForm.endDate === '' || this.dataForm.endDate === null) {
      //   this.dataForm.endDate = ''
      // }
      this.page = 1
      let d = new Date()
      // 由于日期区间是2个国际标准的时间字符串显示进行了下面的判断和转换
      if (this.startdateRange === null || this.startdateRange.length === 0) {
        this.dataForm.startStartDate = ''
        this.dataForm.startEndDate = ''
      } else {
        // 区间的开始日期默认00:00:00
        d = new Date(this.startdateRange[0])
        let start1 = d.getFullYear() + '-' + this.checkTime((d.getMonth() + 1)) + '-' + this.checkTime(d.getDate()) + ' 00:00:00'
        // 区间的结束日期默认23:59:59
        d = new Date(this.startdateRange[1])
        let start2 = d.getFullYear() + '-' + this.checkTime((d.getMonth() + 1)) + '-' + this.checkTime(d.getDate()) + ' 23:59:59'
        this.dataForm.startStartDate = start1
        this.dataForm.startEndDate = start2
      }
      if (this.enddateRange === null || this.enddateRange.length === 0) {
        this.dataForm.endStartDate = ''
        this.dataForm.endEndDate = ''
      } else {
        d = new Date(this.enddateRange[0])
        let end1 = d.getFullYear() + '-' + this.checkTime((d.getMonth() + 1)) + '-' + this.checkTime(d.getDate()) + ' 00:00:00'
        d = new Date(this.enddateRange[1])
        let end2 = d.getFullYear() + '-' + this.checkTime((d.getMonth() + 1)) + '-' + this.checkTime(d.getDate()) + ' 23:59:59'
        this.dataForm.endStartDate = end1
        this.dataForm.endEndDate = end2
      }
      this.getDataList()
    },
    courseDaysformat (row, column, cellValue) {
      return cellValue.toFixed(2)
    },
    // 日期格式
    dateFormat (row, column, cellValue) {
      var datetime = cellValue
      if (datetime) {
        datetime = new Date(datetime)
        let y = datetime.getFullYear() + '-'
        let mon = datetime.getMonth() + 1 + '-'
        let d = datetime.getDate()
        return y + mon + d
      }
      return ''
    },
    // 分配
    assignUser (row) {
      console.log('assignUser start')
      console.info('RRRRRRRR--->>', row)
      this.assignUserVisible = true
      let allDataList = this.dataList
      this.$nextTick(() => {
        /* this.$refs.assignUser.offeringId = row.offeringId
        // 赋值初始化
        this.$refs.assignUser.init() */

        // 跨组件传值
        this.$refs.assignUser.dataofferinginfo.offeringId = row.offeringId
        this.$refs.assignUser.dataofferinginfo.offeringNo = row.offeringNo
        this.$refs.assignUser.dataofferinginfo.courseId = row.courseId
        this.$refs.assignUser.dataofferinginfo.courseCode = row.courseCode
        this.$refs.assignUser.dataofferinginfo.courseNameCn = row.courseNameCn
        this.$refs.assignUser.dataofferinginfo.trainerName = row.trainerName
        this.$refs.assignUser.dataofferinginfo.offeringName = row.offeringName
        this.$refs.assignUser.dataofferinginfo.site = row.site
        this.$refs.assignUser.dataofferinginfo.siteName = row.site
        this.$refs.assignUser.dataofferinginfo.startdate = row.startdate
        this.$refs.assignUser.dataofferinginfo.enddate = row.enddate

        this.$refs.assignUser.dataForm.offeringId = row.offeringId
        this.$refs.assignUser.dataForm.courseId = row.courseId

        this.$refs.assignUser.applyNumber = row.applyNumber
        this.$refs.assignUser.maxNumber = row.maxNumber

        this.$refs.assignUser.parentData = allDataList

        this.$refs.assignUser.init()
        this.$refs.assignUser.getDataListMerge(allDataList)
      })
      this.$router.push({
        query: { offeringId: row.offeringId },
        userId: row.userId,
        registeId: row.registeId
      })
    },
    // 重置
    again () {
      // 培训师列表
      this.dataForm = {
        courseCode: '', // 课程编号
        offeringCode: '', // 排期编号
        offeringName: '', // 排期名称
        offeringStatus: '', // 排期状态
        city: '', // 所在城市
        place: '', // 所在场地
        courseid: '', // 课程ID
        coursename: '' // 课程名称
      }
      this.startdateRange = [] // 开始时间
        this.enddateRange = [] // 结束时间
        //this.getDataList()
    },
    toggle (val) {
      this.isShow = val
    },
    checkTime (i) {
      // 这是时间格式化时一位数补充0的处理
      if (i < 10) {
        i = '0' + i
      }
      return i
    },
    // 调用课程界面
    showCourseView (scope) {
      this.$router.push({
        path: 'learning-course-courseShow',
        query: { courseId: scope.row.courseId }
      })
      this.$eventHub.$emit('showViewCourse', '')
    },
    // 调用排期界面
    showOfferingView (scope) {
      this.$router.push({
        path: 'learning-offering-offeringShow',
        query: { offeringId: scope.row.offeringId }
      })
      this.$eventHub.$emit('showViewOffering', '')
    },
    // 调用人员分配界面(报名人数大于0)
    showUserView (scope) {
      /* eslint-disable */
      // debugger
      if (scope.row.applyNumber > 0) {
        this.$router.push({
          name: 'learning-course-registe-registeuserlist',
          query: {
            registeId: scope.row.registeId,
            offeringId: scope.row.offeringId,
            offeringNo: scope.row.offeringNo,
            courseId: scope.row.courseId,
            courseCode: scope.row.courseCode,
            courseNameCn: scope.row.courseNameCn,
            trainerName: scope.row.trainerName,
            offeringName: scope.row.offeringName,
            site: scope.row.site,
            siteName: scope.row.site,
            startdate: scope.row.startdate,
            enddate: scope.row.enddate
          }
        })
        this.$eventHub.$emit('USER_QUERY_XPY77', '')
        // this.$eventHub.$emit('showViewUser', '')
      }
    },
    offeringstatus (row, column, cellValue) {
      if (cellValue === '10') {
        return '全部'
      } else if (cellValue === '20') {
        return '未发布'
      } else if (cellValue === '30') {
        return '已发布'
      } else if (cellValue === '40') {
        return '已取消'
      } else { return ' ' }
    }
  }
}
</script>
<style scoped>
.el-date-picker.el-input.el-select {
  width: 180px;
}
.search {
  height: 50px;
}
 .search-item .el-form-item__content {
  margin-left: 68px !important;
}
</style>
